const router = [
    {
        path: '/employees',
        name: 'employees',
        redirect: '/employees/list',
        component: () => import('@/modules/Employees/pages'),
        children: [
            {
                path: '/employees/integration-profile',
                name: 'integrationProfile',
                component: () => import('@/modules/Employees/pages/IntegrationProfile'),
                meta: {
                    requiresAuth: true,
                    requiresPermission: true,
                    action: 106
                }
            },
        ],
        meta: {
            requiresAuth: true,
            requiresPermission: true,
            action: 7
        }
    }
]
export default router